import { Input, OnInit, Output, Component, ElementRef, EventEmitter } from '@angular/core';

@Component({
  selector: 'dropdown-pick',
  templateUrl: './dropdown-pick.component.html',
  styleUrls: ['./dropdown-pick.component.scss'],
  host: { '(document:click)': 'onClick($event)' }
})
export class DropdownPickComponent implements OnInit {

  // Inputs variables
  @Input() items: any[];
  @Input() label: string;
  @Input() width: string;

  // Output variables
  @Output() onItemSelect: EventEmitter<any> = new EventEmitter<any>();

  // Dropdown open status
  public dropdownOpened: boolean = false;
  // Selected item
  public itemSelected: string | null;

  // Constructor
  constructor(private _eref: ElementRef) { }

  // On component init
  ngOnInit() {
  }

  // On element click
  public onClick(event): void {
    if (!this._eref.nativeElement.children[0].children[0].contains(event.target) && this.dropdownOpened) this.dropdownOpened = false;
  }

  // Selecting an item
  public itemSelect(event, item): void {
    event.stopPropagation();
    this.onItemSelect.emit(item);
  }

  // Toggle dropdown
  public toggleDropdown(): void {
    this.dropdownOpened = !this.dropdownOpened;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/dropdown-pick/dropdown-pick.component.ts